<script setup lang="ts">
import { CircleAlert, Info } from 'lucide-vue-next';
import type { HTMLAttributes } from 'vue';
import type { AlertVariants } from './alert';
import { alertVariants } from './alert';

const props = defineProps<{
  class?: HTMLAttributes['class'];
  variant?: AlertVariants['variant'];
  size?: AlertVariants['size'];
}>();
</script>

<template>
  <div
    :class="cn(alertVariants({ variant, size }), props.class)"
    role="alert"
  >
    <Info
      v-if="variant === 'info'"
      aria-hidden="true"
      class="shrink-0"
    />
    <CircleAlert
      v-else-if="variant === 'error' || variant === 'warning'"
      aria-hidden="true"
      class="shrink-0"
    />
    <slot />
  </div>
</template>
